import { Group, Paper, Text } from "@mantine/core";
import { Link } from "react-router";

export default function ResourceLinkCard({ label, url }: { label: string; url: string }) {
  return (
    <Paper component={Link} to={url} p="xs" px="sm" radius="md" withBorder mt="xs" style={{ cursor: "pointer" }}>
      <Group gap="xs">
        <Text size="sm" fw={600} c="blue">
          {label}
        </Text>
        <Text size="xs" c="dimmed">
          &rarr;
        </Text>
      </Group>
    </Paper>
  );
}
